import * as TYPES from '../types';
import {ConferenceType, TeamsAction, UpdateTeamsActionTypes } from '../types';

interface DataTeamsState {
  teams: { AFC: ConferenceType; NFC: ConferenceType } | null;
}

const initialState: DataTeamsState = {
  teams: null,
};
export const teamsStandings = (state: DataTeamsState = initialState, action: UpdateTeamsActionTypes) => {
  switch (action.type) {
    case TeamsAction.UPDATE_TEAMS_STANDINGS:
      return action.teams;
    default:
      return state;
  }
};
